import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { BarChart3 } from 'lucide-react';

const SeasonalityTable = ({ seasonalityData }) => {
  if (!seasonalityData || seasonalityData.length === 0) return null;

  const getZScoreBadgeVariant = (zScore) => {
    if (zScore === null || zScore === undefined) return 'secondary';
    const absZScore = Math.abs(zScore);
    if (absZScore > 2) return 'danger';
    if (absZScore > 1) return 'warning';
    return 'success';
  };

  const getChangeBadgeVariant = (change) => {
    if (!Number.isFinite(change)) return 'secondary';
    if (change > 10) return 'success';
    if (change > 0) return 'info';
    if (change > -10) return 'warning';
    return 'danger';
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="card-title mb-0 d-flex align-items-center">
          <BarChart3 className="text-info me-2" size={20} />
          Seasonality Statistics
        </h5>
      </Card.Header>
      <Card.Body>
        <div className="table-responsive">
          <Table striped hover size="sm">
            <thead>
              <tr>
                <th>Month</th>
                <th>Avg</th>
                <th>±Std</th>
                <th>Z-Score</th>
                <th>Change %</th>
              </tr>
            </thead>
            <tbody>
              {seasonalityData.map((stat, index) => (
                <tr key={index}>
                  <td>{stat.month_name}</td>
                  <td>{Math.round(stat.avg_interest)}</td>
                  <td>±{Math.round(stat.std_interest)}</td>
                  <td>
                    <Badge bg={getZScoreBadgeVariant(stat.z_score)}>
                      {stat.z_score !== null && stat.z_score !== undefined 
                        ? stat.z_score.toFixed(2) 
                        : 'N/A'}
                    </Badge>
                  </td>
                  <td>
                    <Badge bg={getChangeBadgeVariant(stat.avg_change)}>
                      {Number.isFinite(stat.avg_change) ? `${stat.avg_change.toFixed(1)}%` : 'N/A'}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SeasonalityTable;